import { useSyncExternalStore } from 'react';

const KEY = 'st.nav.collapsed';

/**
 * Desktop sidebar collapse state (full 240px rail vs 72px icon rail). A provider-free external store backed by
 * localStorage so the choice persists across reloads and every consumer (Sidebar, Topbar, AppLayout) re-renders
 * in sync when it toggles — keeping the fixed shell's widths coordinated with no duplicate global state.
 */
function read(): boolean {
  try { return window.localStorage.getItem(KEY) === '1'; } catch { return false; }
}

let current = read();
const listeners = new Set<() => void>();

export function setSidebarCollapsed(collapsed: boolean) {
  current = collapsed;
  try { window.localStorage.setItem(KEY, collapsed ? '1' : '0'); } catch { /* ignore */ }
  listeners.forEach((l) => l());
}
export function toggleSidebarCollapsed() { setSidebarCollapsed(!current); }

function subscribe(cb: () => void) { listeners.add(cb); return () => { listeners.delete(cb); }; }
function getSnapshot(): boolean { return current; }

export function useSidebarCollapsed() {
  const collapsed = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { collapsed, setCollapsed: setSidebarCollapsed, toggle: toggleSidebarCollapsed };
}
